// App State Persistence Service - React implementation of Angular appStatePersistenceService
// Handles saving and restoring application state before/after login redirects

class AppStatePersistenceService {
  constructor() {
    this.storageKey = "elisaBuilderAppState";
  }

  async saveCurrentAppState() {
    try {
      const appState = {
        url: window.location.href,
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash,
        timestamp: new Date().toISOString(),
        // Add any quiz or application state that needs to be preserved
        quizState: this.getCurrentQuizState(),
        scrollPosition: {
          x: window.scrollX,
          y: window.scrollY,
        },
      };

      localStorage.setItem(this.storageKey, JSON.stringify(appState));
      return Promise.resolve(appState);
    } catch (error) {
      console.error("Error saving app state:", error);
      return Promise.reject(error);
    }
  }

  async restoreAppState() {
    try {
      const savedState = localStorage.getItem(this.storageKey);
      if (!savedState) {
        return null;
      }

      const appState = JSON.parse(savedState);

      // Clean up the saved state
      localStorage.removeItem(this.storageKey);

      return appState;
    } catch (error) {
      console.error("Error restoring app state:", error);
      return null;
    }
  }

  getCurrentQuizState() {
    // Try to get quiz state from various possible sources
    try {
      // From local storage if quiz context saves there
      const quizData =
        localStorage.getItem("quizState") ||
        localStorage.getItem("quizAnswers");
      if (quizData) {
        return JSON.parse(quizData);
      }

      // From session storage
      const sessionQuizData =
        sessionStorage.getItem("quizState") ||
        sessionStorage.getItem("quizAnswers");
      if (sessionQuizData) {
        return JSON.parse(sessionQuizData);
      }

      // Could also try to get from React context or Redux store if available
      return null;
    } catch (error) {
      console.error("Error getting quiz state:", error);
      return null;
    }
  }

  clearSavedState() {
    try {
      localStorage.removeItem(this.storageKey);
    } catch (error) {
      console.error("Error clearing saved state:", error);
    }
  }
}

// Create singleton instance
const appStatePersistenceService = new AppStatePersistenceService();

export default appStatePersistenceService;
